var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorplanline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 454,
    viewBox: "0 0 473 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-484.15 1097.42H-260.852C-229.461 1097.42 -204.013 1071.96 -204.013 1040.54V890.734C-204.013 859.321 -229.461 833.857 -260.852 833.857H-354.739C-386.13 833.857 -411.578 808.392 -411.578 776.98V420.079C-411.578 388.667 -386.13 363.202 -354.739 363.202H154.786C186.177 363.202 211.625 337.736 211.625 306.324V110.707C211.625 79.2947 237.073 53.83 268.465 53.83H414.623C446.015 53.83 471.462 28.3653 471.462 -3.04698V-53.3221",
    stroke: "url(#paint0_linear_9220_5059)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9220_5059",
    x1: -76.753,
    y1: 301.861,
    x2: 468.015,
    y2: 10.3692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#27E8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006C9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorplanline);
export default __webpack_public_path__ + "static/media/vectorplanline.c643585e2f5bd54f45da49c572be23f7.svg";
export { ForwardRef as ReactComponent };